import { useContext } from 'react'
import type { ReactNode } from 'react'
import { useTranslation } from 'next-i18next'
import CircleCheckIcon from 'shared/icons/circle-check-icon'
import { PrimaryButtonWithCustomTheme } from '../components/primary-button-with-custom-theme'
import { addPublicCustomClassNamePrefix } from '../utils/add-class-prefix'
import { CourseQuizScreenWrapper } from './course-quiz-screen-wrapper'
import { CourseQuizStateContext } from './course-quiz-state/context'
import { CourseStatusEnum } from './course-quiz-state/types'

export const CourseQuizFailScreen = (): ReactNode => {
  const { t } = useTranslation()

  const { quizState, setQuizState } = useContext(CourseQuizStateContext)

  return (
    <CourseQuizScreenWrapper
      className={addPublicCustomClassNamePrefix(`course__quiz-results-screen--failed`)}
    >
      <CircleCheckIcon width="43px" height="43px" />
      <span className="mt-6 text-3xl font-bold text-THEME-primary lg:text-5xl">
        {t('course.quiz.fail.title')}
      </span>
      <p className="mt-5 text-base font-semibold text-THEME-primary lg:text-xl">
        {t('course.quiz.fail.percentage', { percentage: quizState?.percentage })}
      </p>
      <div className="mt-7 flex gap-3">
        <PrimaryButtonWithCustomTheme
          className={`shrink-0 basis-6/12 font-bold ${addPublicCustomClassNamePrefix('course__button--retake-quiz')}`}
          onClick={() => setQuizState({ status: CourseStatusEnum.in_progress })}
        >
          {t('course.quiz.fail.retake_button')}
        </PrimaryButtonWithCustomTheme>
      </div>
    </CourseQuizScreenWrapper>
  )
}
